import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Upload, message, } from 'antd';
import { CloseCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import './uploadDocumentModal.css'
import stdApplyJobModalStroke from '../../public/img/std/stdApplyJobModalStroke.png';
import stdApplyJobAdd from '../../public/img/std/stdApplyJobAdd.png';
import tag1 from '../../public/img/tag/tag1.png';
import TurnitinEulaModal from './turnitinEulaModal';

const AttachDocumentModal = (props) => {

    const [documentFileList, setDocumentFileList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [fileSize, setFileSize] = useState('');
    const [isTurnitinEulaModal, setIsTurnitinEulaModal] = useState(false);
    const [studentModuleAssignModel, setStudentModuleAssignModel] = useState(props.studentModuleAssignModel);
    const [form] = Form.useForm();

    useEffect(() => {
        searchFileSize();
        if(props.editFlag == 'edit') {
            searchById();
        }
    }, []);

    const searchFileSize = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'FILE_SIZE',
        }
        Base.callBackApi("commonDropDown/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                const sizeNumber = parseInt(data.object?.parmValue1 ?? '');
                const size = isNaN(sizeNumber) ? 10 : sizeNumber;
                setFileSize(size);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }
    
    const searchById = () => {
        Base.callBackApi("assign/searchById", studentModuleAssignModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data?.object ?? {};
                setDocumentFileList([{
                        uid: model.filePath,
                        name: model.fileName,
                        path: model.filePath,
                        url: Config.keyDocument + model.filePath,
                        status: 'old'
                    }
                ]);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { });
    }

    const handleDocumentChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFileList(newFileList);
            return
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const deleteFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFileList(newList);
    }

    const beforeUpload = (file) => {
        // 检查当前已上传文件数量
        if (documentFileList.length >= 1) {
            message.error('Maximum uploads 1 files.');
            return false; // 阻止上传
        }
        return true; // 允许上传
    };

    const onFinish = () => {
        let values = {status: 'WIP'}
        if (Base.isEmpty(documentFileList)) {
            message.error('Please select file.');
            return
        }
        if (studentModuleAssignModel?.turnitinReqInd == 'Y' && studentModuleAssignModel?.turnitinEulaInd != 'Y') {
            setIsTurnitinEulaModal(true);
            return;
        }
        let formData = new FormData();
        for (let file of documentFileList) {
            if (file.status != undefined && file.status != 'old') {
                formData.append('file', file.originFileObj);
            } else {
                values.filePath = file.path;
                values.fileName = file.name;
            }
        }
        values.studentModuleAssignId = studentModuleAssignModel?.studentModuleAssignId;
        values.lastUpdatedDate = studentModuleAssignModel?.lastUpdatedDate;
        formData.append("model", JSON.stringify(values));
        props.onClose(true, formData);
    }

    const closeTurnitinEulaModal = (flag) => {
        setIsTurnitinEulaModal(false);
        if (flag) {
            studentModuleAssignModel.turnitinEulaInd = 'Y';
            form.submit();
        }
    }

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='805px'//弹框宽度
            footer={false}
            className='uploadDocumentModal'
        >
            {isTurnitinEulaModal && <TurnitinEulaModal onClose={closeTurnitinEulaModal}/>}
            <div className='box'>
                <div className='title'>{props.editFlag === 'add' ? 'Upload' : 'Replace'}</div>
                <Form form={form} onFinish={onFinish}>
                    <div className='row attachment'>
                        <div className='label mustFill'>Attachment</div>
                        <Upload
                            maxCount={1}
                            beforeUpload={beforeUpload}
                            action={Config.assignmentUploadServer}
                            key={"1"}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                            fileList={documentFileList}
                            onChange={(file) => handleDocumentChange(file)}
                            showUploadList={false}>
                            <Button icon={<UploadOutlined />}>Select Document</Button>
                        </Upload>
                    </div>
                    <div className='row attachment'>
                        <div className='label'></div>
                        <div className='allFileBox'>
                            {documentFileList.map((item, index) =>
                                <div className="uploadFileRow " key={index} title={item.name}>
                                    <img src={tag1} className="tagImg"></img>
                                    <div className='fileBox'>{item.name}</div>
                                    <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteFile(index)} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='row'>
                        - 1 file, max 10MB, recommended file type is .pdf.<br/>
                        {`- Store large content (e.g., photos, videos) on the student's OneDrive or Panapto. Include links in the assignment for submission.`}<br/>
                        - Upload: Supported types are .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt.<br/>
                        - View: Non-PDF types may not be displayed or aligned correctly.<br/>
                        - Remove the current file before uploading a new one.<br/>
                        - If assignment is Turnitin-flagged, the file cannot be Deleted/Replaced until Turnitin score is returned.
                    </div>
                    <div className="buttonBox">
                        <div className='saveButton' onClick={() => form.submit()}><img src={stdApplyJobAdd} />Save</div>
                        <div className='cancelButton' onClick={() => props.onClose(false)}><img src={stdApplyJobModalStroke} />Cancel</div>
                    </div>
                </Form>
            </div>
        </Modal>
    )
}

AttachDocumentModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    studentModuleAssignModel: PropTypes.object.isRequired,
    editFlag: PropTypes.string.isRequired,
}
export default AttachDocumentModal;